(function (window, document) {
  console.log("MVT Engine: Session-track module loaded");

  const Utils = window.MVTUtils;

  const SESSION_STORAGE_KEY_PREFIX = "__mvt_session_id_v1__::";

  const ENGAGEMENT_DWELL_MS = 10_000;

  const ENGAGEMENT_SCROLL_FRACTION = 0.25;

  function uuidv4Fallback() {
    if (typeof window.crypto !== "undefined" && typeof window.crypto.randomUUID === "function") {
      try {
        return window.crypto.randomUUID();
      } catch (e) {}
    }
    const bytes = new Uint8Array(16);
    if (typeof window.crypto !== "undefined" && window.crypto.getRandomValues) {
      window.crypto.getRandomValues(bytes);
    } else {
      for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
    }
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = [];
    for (let i = 0; i < 16; i++) {
      hex.push((bytes[i] + 0x100).toString(16).substring(1));
    }
    return (
      hex.slice(0, 4).join("") +
      "-" +
      hex.slice(4, 6).join("") +
      "-" +
      hex.slice(6, 8).join("") +
      "-" +
      hex.slice(8, 10).join("") +
      "-" +
      hex.slice(10, 16).join("")
    );
  }

  function getOrCreateSessionId(projectKey) {
    const key = SESSION_STORAGE_KEY_PREFIX + projectKey;
    try {
      const existing = window.sessionStorage.getItem(key);
      if (existing) return existing;
      const fresh = uuidv4Fallback();
      window.sessionStorage.setItem(key, fresh);
      return fresh;
    } catch (e) {
      return uuidv4Fallback();
    }
  }

  const SESSION = {
    _started: false,
    _sessionId: null,
    _visitorId: null,
    _projectKey: null,
    _publicApiBase: null,
    _campaignId: null,
    _engaged: false,
    _dwellMs: 0,
    _lastTickMs: null,
    _endFired: false,

    start(opts) {
      const projectKey = opts && opts.projectKey;
      const publicApiBase = opts && opts.publicApiBase;
      if (!projectKey || !publicApiBase || !Utils) {
        return;
      }
      if (this._started) {
        this.recordPageview(opts);
        return;
      }
      this._started = true;

      if (Utils && Utils.consentBlocked && Utils.consentBlocked()) {
        this._started = false;
        return;
      }

      this._projectKey = projectKey;
      this._publicApiBase = publicApiBase;
      this._visitorId = Utils.getOrCreateVisitorId(projectKey);
      this._sessionId = getOrCreateSessionId(projectKey);
      this._campaignId = (opts && opts.campaignId) || null;
      this._lastTickMs = Date.now();

      this._attachEngagementListeners();
      this._sendStart();
    },

    recordPageview(opts) {
      if (!this._started) {
        this.start(opts);
        return;
      }
      if (opts && opts.campaignId && !this._campaignId) {
        this._campaignId = opts.campaignId;
      }
      this._sendStart();
    },

    _sendStart() {
      if (Utils && Utils.consentBlocked && Utils.consentBlocked()) {
        return;
      }
      try {
        const url = this._publicApiBase + "/track/session/start";
        const body = {
          sessionId: this._sessionId,
          visitorId: this._visitorId,
          projectId: this._projectKey,
          campaignId: this._campaignId || undefined,
          pageUrl: window.location.href,
          referrerUrl: document.referrer || undefined,
        };

        fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
          keepalive: true,
        }).catch(() => {});
      } catch (e) {}
    },

    _attachEngagementListeners() {
      const self = this;

      const onClick = function () {
        self._engaged = true;
      };

      const onScroll = function () {
        if (self._engaged) return;
        try {
          const scrollable = Math.max(
            0,
            (document.documentElement && document.documentElement.scrollHeight
              ? document.documentElement.scrollHeight
              : document.body.scrollHeight) - window.innerHeight,
          );
          if (scrollable <= 0) return;
          const scrolled = window.pageYOffset || document.documentElement.scrollTop || 0;
          if (scrolled / scrollable >= ENGAGEMENT_SCROLL_FRACTION) {
            self._engaged = true;
          }
        } catch (e) {}
      };

      const onVisibilityChange = function () {
        self._tickDwell();
        if (document.visibilityState === "hidden") {
          self._fireEnd();
        } else if (document.visibilityState === "visible") {
          self._lastTickMs = Date.now();
        }
      };

      const onPageHide = function () {
        self._tickDwell();
        self._fireEnd();
      };

      try {
        document.addEventListener("click", onClick, { passive: true });
        window.addEventListener("scroll", onScroll, { passive: true });
        document.addEventListener("visibilitychange", onVisibilityChange, {
          passive: true,
        });
        window.addEventListener("pagehide", onPageHide, { passive: true });
      } catch (e) {}
    },

    _tickDwell() {
      try {
        if (document.visibilityState !== "visible") return;
        const now = Date.now();
        if (this._lastTickMs) {
          const delta = now - this._lastTickMs;
          if (delta > 0 && delta < 60_000) {
            this._dwellMs += delta;
            if (this._dwellMs >= ENGAGEMENT_DWELL_MS) {
              this._engaged = true;
            }
          }
        }
        this._lastTickMs = now;
      } catch (e) {}
    },

    _fireEnd() {
      if (this._endFired) return;

      if (Utils && Utils.consentBlocked && Utils.consentBlocked()) {
        this._endFired = true;
        return;
      }
      this._endFired = true;
      try {
        const url = this._publicApiBase + "/track/session/end";
        const body = JSON.stringify({
          sessionId: this._sessionId,
          visitorId: this._visitorId,
          dwellMs: Math.max(0, Math.floor(this._dwellMs)),
          engaged: this._engaged,
        });

        if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
          const blob = new Blob([body], { type: "application/json" });
          navigator.sendBeacon(url, blob);
        } else {
          fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: body,
            keepalive: true,
          }).catch(() => {});
        }
      } catch (e) {}
    },
  };

  window.MVTSessionTrack = SESSION;
})(window, document);
